module.exports = __webpack_public_path__ + "ef41be0a1862e1e7009e65531d67ce06.mp3";